import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { AnnouncementDetailsComponent } from '../announcement-details/announcement-details.component';
import { AnnouncementHistoryComponent } from '../announcement-history/announcement-history.component';
import { AnnouncementDetails } from '../../../../../shared/models/announcement-details';

@Component({
  selector: 'app-admin-panel-announcement-preview',
  imports: [
    AnnouncementDetailsComponent,
    AnnouncementHistoryComponent,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
  ],
  templateUrl: './admin-panel-announcement-preview.html',
  styleUrl: './admin-panel-announcement-preview.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelAnnouncementPreview {
  protected readonly announcement = input<AnnouncementDetails | null>(null);
}
